import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { dismissVsbUpsellAlert, setCTAClickedVsbUpsellAlert } from '../../app/appActions';
import { compareM365PlansUrlSelector, isGetHelpSelector, isVsbUpsellAlertCTAClickedSelector, isVsbUpsellAlertDismissedSelector, originalQuerySelector, shouldShowVsbUpsellAlertSelector } from '../../app/selectors/contactUsSelector';
import { VsbUpsellAlert } from '../presentationalComponents/VsbUpsellAlert';
import { getVsbUpsellAlertStyles } from '../styles/vsbUpsellAlertStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
    return {
        shouldShowVsbUpsellAlert: shouldShowVsbUpsellAlertSelector(state),
        isVsbUpsellAlertDismissed: isVsbUpsellAlertDismissedSelector(state),
        isVsbUpsellAlertCTAClicked: isVsbUpsellAlertCTAClickedSelector(state),
        compareM365PlansUrl: compareM365PlansUrlSelector(state),
        originalQuery: originalQuerySelector(state),
        isGetHelp: isGetHelpSelector(state),
    };
};

const mapDispatchToProps = {
    dismissVsbUpsellAlert,
    setCTAClickedVsbUpsellAlert,
};

export const VsbUpsellAlertContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(styled(VsbUpsellAlert, getVsbUpsellAlertStyles));
